import { profileApiSlice } from './slices';

export const profileSlices = {
  [profileApiSlice.reducerPath]: profileApiSlice.reducer,
};

export { useGetMeQuery, useUpdateMeMutation } from './slices';
